var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrap-container',{staticClass:"container"},[_c('a',{attrs:{"href":"https://www.bbva.com.ar/empresas.html"}},[_c('wrap-container',{staticClass:"text-container"},[_c('p',[_vm._v(" Si querés conocer más sobre nuestros productos para empresas"),_c('br'),_vm._v(" ingresá a "),_c('strong',[_vm._v("bbva.com.ar/empresas")])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }